import React from 'react'
import './LoadingPage.css'

const LoadingPage = () => {
  // window.trackPage('LoadingScreen') // don't track for now

  // forward app traffic to my evanta, sometimes user can hit loading screen (coming from wizard)
  if(process.env.REACT_APP_CURRENT_ENV === 'development') {
    window.location.assign('http://localhost:1340')
  } else if(process.env.REACT_APP_CURRENT_ENV === 'staging'){
    window.location.assign('https://qa-my.evanta.com/')
  } else {
    window.location.assign('https://my.evanta.com')
  }
  return (
    <div className="loading-page h-100 justify-content-center align-items-center">
      {/* <div className="loading-page-logo">
        <img src="/evanta_logo_white.png" alt="loading page"/>
      </div>
      <div className="center-progress-display">
        <i className="fa fa-spinner fa-spin"></i>
        <div className="progress" style={{ backgroundColor: '#888' }}>
          <div className="bar"
            role="progressbar"
            style={{ width: `${percentLoaded}%` }}
            aria-valuenow={ percentLoaded }
            aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
        <div className="number-display">{ percentLoaded }%</div>
      </div> */}
    </div>
  )
}

export default LoadingPage
